import SelfTabs from './SelfTabs'

export default SelfTabs